import { useMemo, useRef } from 'react';
import { isEqual } from 'lodash';

export function useDeepCompareMemo<T>(factory: () => T, dependencies: any[]): T {
  const previousDependencies = useRef<any[]>();

  if (!isEqual(previousDependencies.current, dependencies)) {
    previousDependencies.current = dependencies;
  }

  return useMemo(factory, previousDependencies.current || []);
}
